module.exports = "pegasus/assets/themelp1/launch/200.png";